import { AssistantPlanFieldCard } from "@/components/assistant/AssistantPlanFieldCard";
import { AssistantPlanItemCard } from "@/components/assistant/AssistantPlanItemCard";
import type { WriteApprovalPlanCardGroup } from "@/components/assistant/formatWriteApprovalSummary";

type Props = {
  groups: WriteApprovalPlanCardGroup[];
};

export function AssistantPlanCardsView({ groups }: Props) {
  if (groups.length === 0) {
    return (
      <p className="text-sm text-[#576274] dark:text-gray-400">No plan details to display.</p>
    );
  }

  return (
    <div className="space-y-6">
      {groups.map((group) => (
        <section key={group.id} className="space-y-3">
          <h4 className="text-[11px] font-medium uppercase tracking-wide text-[var(--lm-muted)] dark:text-slate-400">
            {group.title}
          </h4>
          {group.layout === "field-grid" ? (
            <div className="grid grid-cols-1 gap-2.5 sm:grid-cols-2">
              {group.fields.map((field) => (
                <AssistantPlanFieldCard key={field.id} field={field} />
              ))}
            </div>
          ) : (
            <div className="space-y-2.5">
              {group.items.map((item) => (
                <AssistantPlanItemCard key={item.id} item={item} />
              ))}
            </div>
          )}
        </section>
      ))}
    </div>
  );
}
